export default "__VITE_ASSET__CELdkfPd__"